var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 118,
    viewBox: "0 0 170 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 18)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 10)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_805_9487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 70,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.667 63.3333V25H118.334V63.3333C118.334 65.1667 116.834 66.6667 115 66.6667H55.0003C53.167 66.6667 51.667 65.1667 51.667 63.3333Z",
    fill: "#35C1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.334 16.6667V25H51.667V16.6667C51.667 14.8334 53.167 13.3334 55.0003 13.3334H115C116.834 13.3334 118.334 14.8334 118.334 16.6667Z",
    fill: "url(#paint0_linear_805_9487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5003 21.6666H114.167C114.627 21.6666 115 21.2933 115 20.8333V17.5C115 17.04 114.627 16.6666 114.167 16.6666H72.5003C72.0403 16.6666 71.667 17.04 71.667 17.5V20.8333C71.667 21.2933 72.0403 21.6666 72.5003 21.6666Z",
    fill: "url(#paint1_linear_805_9487)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 21.6666C58.8807 21.6666 60 20.5473 60 19.1666C60 17.7859 58.8807 16.6666 57.5 16.6666C56.1193 16.6666 55 17.7859 55 19.1666C55 20.5473 56.1193 21.6666 57.5 21.6666Z",
    fill: "url(#paint2_linear_805_9487)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.833 21.6666C67.2137 21.6666 68.333 20.5473 68.333 19.1666C68.333 17.7859 67.2137 16.6666 65.833 16.6666C64.4523 16.6666 63.333 17.7859 63.333 19.1666C63.333 20.5473 64.4523 21.6666 65.833 21.6666Z",
    fill: "url(#paint3_linear_805_9487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0003 43.3333C71.8413 43.3333 73.3337 41.8409 73.3337 40C73.3337 38.159 71.8413 36.6666 70.0003 36.6666C68.1594 36.6666 66.667 38.159 66.667 40C66.667 41.8409 68.1594 43.3333 70.0003 43.3333Z",
    fill: "#057093"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70 45C67.2383 45 65 47.2383 65 50V54C65 54.5517 65.4483 55 66 55H74C74.5517 55 75 54.5517 75 54V50C75 47.2383 72.7617 45 70 45Z",
    fill: "#057093"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.334 45H83.3337C82.4137 45 81.667 45.7467 81.667 46.6667C81.667 47.5867 82.4137 48.3333 83.3337 48.3333H103.334C104.254 48.3333 105 47.5867 105 46.6667C105 45.7467 104.254 45 103.334 45Z",
    fill: "#057093"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.667 51.6666H83.3337C82.4137 51.6666 81.667 52.4133 81.667 53.3333C81.667 54.2533 82.4137 55 83.3337 55H96.667C97.587 55 98.3337 54.2533 98.3337 53.3333C98.3337 52.4133 97.587 51.6666 96.667 51.6666Z",
    fill: "#057093"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.334 38.3334H83.3337C82.4137 38.3334 81.667 39.08 81.667 40C81.667 40.92 82.4137 41.6667 83.3337 41.6667H103.334C104.254 41.6667 105 40.92 105 40C105 39.08 104.254 38.3334 103.334 38.3334Z",
    fill: "#057093"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_9487",
    x: 31,
    y: 36,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_805_9487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_9487",
    x1: 52.6903,
    y1: 12.9017,
    x2: 116.56,
    y2: 25.8884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_9487",
    x1: 71.667,
    y1: 19.1666,
    x2: 115,
    y2: 19.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45B0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_805_9487",
    x1: 56.2517,
    y1: 17.36,
    x2: 58.3867,
    y2: 20.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_805_9487",
    x1: 64.5847,
    y1: 17.36,
    x2: 66.7197,
    y2: 20.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeTile);
export default __webpack_public_path__ + "static/media/resumeTile.5706fe147d28f71bb1e3844c06ead673.svg";
export { ForwardRef as ReactComponent };